export const LIFE_INSURENCE_TARIFF_ROUTE_PREFIX = "/settings/life-insurance-tariffs";

export const LIFE_INSURENCE_TARIFF_ROUTE_PATHS = {
  list: { path: "*", to: LIFE_INSURENCE_TARIFF_ROUTE_PREFIX },
};
